import { render, staticRenderFns } from "./PartnerReferral.vue?vue&type=template&id=42d353c1&"
import script from "./PartnerReferral.vue?vue&type=script&lang=js&"
export * from "./PartnerReferral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports